import { Settings } from "luxon";
import { matchSystemLocale } from "../OS/getActiveLocale";

const months = {
  en: [
    { narrow: "J", short: "Jan", long: "January" },
    { narrow: "F", short: "Feb", long: "February" },
    { narrow: "M", short: "Mar", long: "March" },
    { narrow: "A", short: "Apr", long: "April" },
    { narrow: "M", short: "May", long: "May" },
    { narrow: "J", short: "Jun", long: "June" },
    { narrow: "J", short: "Jul", long: "July" },
    { narrow: "A", short: "Aug", long: "August" },
    { narrow: "S", short: "Sep", long: "September" },
    { narrow: "O", short: "Oct", long: "October" },
    { narrow: "N", short: "Nov", long: "November" },
    { narrow: "D", short: "Dec", long: "December" },
  ],
  sv: [
    { narrow: "J", short: "jan", long: "Januari" },
    { narrow: "F", short: "feb", long: "Februari" },
    { narrow: "M", short: "mars", long: "Mars" },
    { narrow: "A", short: "apr", long: "April" },
    { narrow: "M", short: "maj", long: "Maj" },
    { narrow: "J", short: "juni", long: "Juni" },
    { narrow: "J", short: "juli", long: "Juli" },
    { narrow: "A", short: "aug", long: "Augusti" },
    { narrow: "S", short: "sep", long: "September" },
    { narrow: "O", short: "okt", long: "Oktober" },
    { narrow: "N", short: "nov", long: "November" },
    { narrow: "D", short: "dec", long: "December" },
  ],
  nb: [
    { narrow: "J", short: "jan", long: "Januar" },
    { narrow: "F", short: "feb", long: "Februar" },
    { narrow: "M", short: "mar", long: "Mars" },
    { narrow: "A", short: "apr", long: "April" },
    { narrow: "M", short: "mai", long: "Mai" },
    { narrow: "J", short: "jun", long: "Juni" },
    { narrow: "J", short: "jul", long: "Juli" },
    { narrow: "A", short: "aug", long: "August" },
    { narrow: "S", short: "sep", long: "September" },
    { narrow: "O", short: "okt", long: "Oktober" },
    { narrow: "N", short: "nov", long: "November" },
    { narrow: "D", short: "des", long: "Desember" },
  ],
};

export function useMonths(type: "narrow" | "short" | "long", locale?: string) {
  const l = locale ?? Settings.defaultLocale;
  const matchedLocale = matchSystemLocale(l);
  return months[matchedLocale]?.map((v) => v[type]) ?? [];
}
